const binding = { modules: {}, dataActions: {} };

    (binding.modules['ext-password-reset-verification'] = {
        c: () => require('partner/modules/ext-password-reset-verification/ext-password-reset-verification.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ext-password-reset-verification',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ext-password-reset-verification'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ext-password-reset-verification|ext-password-reset-verification'] = {
                c: () => require('partner/modules/ext-password-reset-verification/ext-password-reset-verification.view.tsx'),
                cn: '__local__-__local__-ext-password-reset-verification'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };